import Select, { type MultiValue } from 'react-select';
import { FILTER_SELECT_WIDTH, filterSelectStyles } from './selectStyles';
import type { SelectOption } from './selectTypes';

export type { SelectOption };

type Props = {
  options: SelectOption[];
  value: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  width?: number | string;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export const MultiSelect = ({
  options,
  value,
  onChange,
  placeholder = 'Выбрать...',
  width = FILTER_SELECT_WIDTH,
  isLoading,
  isDisabled,
}: Props) => {
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Select
      isMulti
      isClearable
      isSearchable
      isLoading={isLoading}
      isDisabled={isDisabled}
      placeholder={placeholder}
      options={options}
      value={selected}
      onChange={(next: MultiValue<SelectOption>) => onChange(next.map((o) => o.value))}
      noOptionsMessage={() => 'Нет вариантов'}
      styles={filterSelectStyles<true>(width)}
      classNamePrefix="filter-multi"
    />
  );
};
